
<template>
    <div>
      <vs-row>
        <vs-col>
         <div class="mb-2">
           <vs-dropdown class="mr-2 mt-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
             <vs-chip transparent color="primary" style="min-width: 130px;">
               <b>From</b>: {{since}}
             </vs-chip>
             <vs-dropdown-menu class="loginx">
               <datepicker @input="fetchMetrics" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
             </vs-dropdown-menu>
           </vs-dropdown>

           <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
             <vs-chip transparent color="primary" style="min-width: 130px;">
               <b>To</b>: {{until}}
             </vs-chip>
             <vs-dropdown-menu class="loginx">
               <datepicker @input="fetchMetrics" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
             </vs-dropdown-menu>
           </vs-dropdown>
         </div>
        </vs-col>
      </vs-row>
        <div class="vx-row">
            <div class="vx-col w-1/2 md:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="MapIcon"
                  :statistic="general.trips"
                  statisticTitle="Trips" />
            </div>

            <div class="vx-col w-1/2 md:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="UserIcon"
                  :statistic="general.users"
                  statisticTitle="Users"
                  color="success" />
            </div>

            <div class="vx-col w-1/2 md:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ShoppingBagIcon"
                  :statistic="general.bookings"
                  statisticTitle="Bookings"
                  color="warning" />
            </div>

            <div class="vx-col w-1/2 md:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="BarChart2Icon"
                  :statistic="general.sales"
                  statisticTitle="Sales"
                  color="danger" />
            </div>
        </div>


      <div class="vx-row" v-if="metrics.length > 0">
        <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2">
          <vs-card>
            <div slot="header" class="p-2">
              <h3>Trips</h3>
            </div>
            <LineChart :data="metrics" label="trips" color="rgb(115, 103, 240)" />
          </vs-card>
        </div>
        <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2">
          <vs-card>
            <div slot="header" class="p-2">
              <h3>Users</h3>
            </div>
            <LollipopChart :data="metrics" label="users" color="rgb(40, 199, 111)"  />
          </vs-card>
        </div>
      </div>

      <div class="vx-row" v-if="metrics.length > 0">
        <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2">
          <vs-card>
            <div slot="header" class="p-2">
              <h3>Bookings</h3>
            </div>
            <LollipopChart :data="metrics" label="bookings" color="rgb(255, 159, 67)" />
          </vs-card>
        </div>
        <div class="vx-col w-1/2 md:w-1/2 xl:w-1/2">
          <vs-card>
            <div slot="header" class="p-2">
              <h3>Sales</h3>
            </div>
            <LineChart :data="metrics" label="sales" color="rgb(234, 84, 85)" />
          </vs-card>
        </div>
      </div>

		</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import {mapState, mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import LineChart from "../components/charts/LineChart";
import LollipopChart from "../components/charts/LollipopChart";
import Datepicker from 'vuejs-datepicker';
import { CalendarIcon, FlagIcon, BriefcaseIcon,
  GitBranchIcon, TruckIcon, UserIcon, XIcon, PlusIcon, FilterIcon } from 'vue-feather-icons'

export default {
  name: 'Home',
	components: {
    StatisticsCardLine,
    LineChart,
    LollipopChart,
    Datepicker,
    CalendarIcon
  },
  data(){
	  return {
	    metrics : [],
      general : {
	      bookings: 0,
        sales: 0,
        trips: 0,
        users: 0,
      },
      dates : {
	      since: moment().subtract(4,'weeks').toDate(),
        until: moment().toDate()
      }
    }
  },
  computed : {
	  ...mapState('metrics', ['stats']),
    ...mapGetters('users',['userCan']),
    ...mapState('users', ['permissions']),

    since(){
	    return moment(this.dates.since).format('YYYY-MM-DD');
    },
    until(){
      return moment(this.dates.until).format('YYYY-MM-DD');
    }
  },
  created() {
	  if(this.userCan('stats.read')){
      this.fetchMetrics();
    }else{
	    if(this.permissions.indexOf('capacity_control_user.read') > -1){
	      this.$router.push({name:'partner.users'});
      }
    }
  },
  methods : {
	  ...mapActions('metrics', ['fetchStats']),
    fetchMetrics(){
      this.$vs.loading({type:'point'});

      this.fetchStats({
        since: this.since,
        until : this.until
      }).then(data=>{
        this.metrics = data;
        let general = {
          bookings: 0,
          sales: 0,
          trips: 0,
          users: 0,
        };
        for(let item of data){
          general.bookings+=item.bookings;
          general.sales+=item.sales;
          general.trips+=item.trips;
          general.users+=item.users;
        }
        this.general = general;
        this.$vs.loading.close()
      }).catch(error =>{
        this.$vs.loading.close()
      });

    }
  }
}
</script>
